// Import markdown files as strings
import perShiftThresholdMd from '../descriptions/per_shift_threshold.md?raw';
import perWeekThresholdMd from '../descriptions/weekly_threshold.md?raw';
import multiplierRateMd from '../descriptions/multiplier_rate.md?raw';
import dayRateHoursAccumulationMethodMd from '../descriptions/hours_accumulation_method.md?raw';
import overtimeConcurrencyStrategyMd from '../descriptions/overtime_concurrency_strategy.md?raw';

export const fieldDescriptions = {
  per_shift_threshold: perShiftThresholdMd,
  weekly_threshold: perWeekThresholdMd,
  multiplier_rate: multiplierRateMd,
  hours_accumulation_method: dayRateHoursAccumulationMethodMd,
  overtime_concurrency_strategy: overtimeConcurrencyStrategyMd,
} as const;

export type FieldDescriptionType = keyof typeof fieldDescriptions;
